import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  text: string;
  subtitle?: string;
  onClick?: () => void;
  className?: string;
}
const CHECKOUT_URL = 'https://mjebook.com/cart/43104594493558:1';
export function CtaButton({
  text,
  subtitle,
  onClick,
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      trackAddToCart();
      window.open(CHECKOUT_URL, '_blank');
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`relative group overflow-hidden rounded-full bg-gradient-to-r from-gold-400 to-gold-500 px-8 py-4 text-lg font-semibold text-navy-900 shadow-[0_0_20px_rgba(212,165,116,0.3)] transition-all hover:shadow-[0_0_30px_rgba(212,165,116,0.5)] ${className}`} data-id="element-1">
      <span className="relative z-10 flex flex-col items-center" data-id="element-2">
        <span data-id="element-3">{text}</span>
      </span>
      <div className="absolute inset-0 -translate-x-full bg-white/20 transition-transform duration-500 group-hover:translate-x-full" data-id="element-4" />
    </motion.button>;
}